import { IconKey,IconDashboard } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconDashboard
};
//

const Dashboards = {

    id: 'dashboards',
    title: 'Dashboards',
    type: 'group',
    display_id:'T',
    icon: icons.IconDashboard,
    children: [
        {
            id: 'commission_reports',
            title: 'Commission Ratna Dashboard',
            type: 'item',
            display_id:80,
            url: '/Department/ratna/transaction_reports',
            breadcrumbs: false
        },
        {
            id: 'csp_activity',
            title: 'CSP Activity',
            type: 'item',
            display_id:78,
            url: '/Department/csp_activity',
            breadcrumbs: false
        },
        {
            id: 'transaction_report',
            title: 'Transaction Report',
            type: 'item',
            display_id:79,
            url: '/Department/transaction_report',
            breadcrumbs: false
        },
        {
            id: 'code_activation',
            title: 'Code Activation',
            type: 'item',
            display_id:75,
            url: '/Department/code_activation',
            breadcrumbs: false
        },
        
        {
            id: 'MATM Activation Report',
            title: 'MATM Activation Report',
            type: 'item',
            display_id:81,
            url: '/Department/MATM_Activation_Report',
            breadcrumbs: false
        },
        {
            id: 'Passbook printer Activation Report',
            title: "Passbook printer Activation Report",
            type: 'item',
            display_id: 82,
            url: '/Department/Passbook_printer_Activation_Report',
            breadcrumbs: false
        },
        {
            id: 'Tab Activation Report',
            title: "Tab Activation Report",
            type: 'item',
            display_id: 83,
            url: '/Department/Tab_Activation_Report',
            breadcrumbs: false
        },
        {
            id: 'csp_network',
            title: 'CSP Network',
            type: 'item',
            display_id:76,
            url: '/Department/csp_network',
            breadcrumbs: false
        },
        {
            id: 'mandate',
            title: 'Mandate',
            type: 'item',
            display_id:77,
            url: '/Department/mandate',
            breadcrumbs: false
        },
        {
            id: 'Non_FI_Activity',
            title: 'Non FI Activity',
            type: 'item',
            display_id:86,
            url: '/Department/Non_FI_Activity',
            breadcrumbs: false
        },
        {
            id: 'Non_FI_Transaction',
            title: 'Non FI Transaction',
            type: 'item',
            display_id:87,
            url: '/Department/Non_FI_Transaction',
            breadcrumbs: false
        },
    ]
}

export default Dashboards;


